/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  isSearchLoading,
  isUserLoggedIn,
  isLoading,
  logout,
  isCartOpened,
  getCurrentPathname,
  storeCommonData,
  storeCountries,
  storeToken,
  getMEC,
  toggleCategorySidebar,
  toggleOrderTypeDropdown,
  submitOpenedOrders,
  toggleCustomerDetail,
} from '../store/common'
import { customerActionType } from '../store/customer'
import shop, { abortFetching } from '../api/shop'
import { store } from '../main'
import { getTranslate, getActiveLanguage } from 'react-localize-redux'
import Header from './Header'
import Sidebar from './Sidebar'
import CartContainer from '../containers/Cart/CartContainer'
import JwtDecode from 'jwt-decode'
import moment from 'moment'
import LoginModal from '../molecules/components/LoginModal'
import ProductModalContainer from '../containers/ProductModal'
import OrderModalContainer from '../containers/OrderModal'
import SubmitOpenedOrderModal from '../containers/SubmitOpenedOrderModal'
import ConfirmOrderModal from '../containers/ConfirmOrderModal'
import ErrorModal from '../containers/ErrorModal'
import CustomerCartModal from '../containers/CustomerCartModal'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
  Button,
  Collapse,
} from 'reactstrap'
import { loadProducts } from '../utils/product.util'
import MediaQuery from 'react-responsive'
import CustomerActionRow from '../routes/CustomerList/components/CustomerActionRow'
import CustomerDetailSection from '../molecules/containers/CustomerDetailSection'

class PageLayout extends Component {
  componentWillMount() {
    const token = localStorage.getItem('token')
    if (token) {
      const tokenClaims = JwtDecode(token)
      if (moment(tokenClaims.exp * 1000) > moment()) {
        store.dispatch(storeToken(token))
        store.dispatch(storeCommonData())
        store.dispatch(getMEC())
      } else {
        store.dispatch(logout(true))
      }
    } else {
      store.dispatch(logout(true))
    }

    shop.getCountries(countriesFromApi => {
      countriesFromApi.then(countries =>
        store.dispatch(storeCountries(countries))
      )
    }, 0)
  }

  changeOrderTypeAndReloadProducts = orderType => {
    abortFetching();
    this.props.customerActionType(orderType)
    loadProducts()
  };

  render() {
    const {
      currentPage,
      main,
      category,
      customerId,
      customer,
      customerPriceLevel,
      customerDiscount,
      isOpen,
      translate,
      isCategoryOpen,
      toggleCategorySidebar,
      isOrderTypeDropdownOpen,
      toggleOrderTypeDropdown,
      orderTypes,
      customerActionType,
      orderType,
      openedOrders,
      submitOpenedOrders,
      customerOrderTypes,
      userCredit,
      showCustomerDetail,
      toggleCustomerDetail
    } = this.props

    if (currentPage === '/login') return main

    return (
      <React.Fragment>
        <Header />
        <Sidebar
          categories={category}
          hideSidebar={translate('layouts.sidebar.hide_sidebar')}
          isCategoryOpen={isCategoryOpen}
          toggleCategorySidebar={toggleCategorySidebar}
        />
        <div className='flexbox'>
          <div className={'cartBar ' + (isCartOpened ? '' : 'disabled')}>
            <CartContainer />
          </div>
          <div className='container-fluid'>
            {currentPage !== '/' &&
              currentPage !== '/salesmen' &&
              currentPage !== '/sales' &&
              currentPage !== '/orders' ? (
                <React.Fragment>
                  <div className='header__customer'>
                    <div className='customers_section'>
                      <Button
                        type="button"
                        className={
                          "btn-danger button-customer-detail " + (showCustomerDetail ? "active" : "")
                        }
                        onClick={() => toggleCustomerDetail()}
                      />
                      {customer}
                      <div className='sale'>
                        {customerPriceLevel &&
                          '( ' +
                          translate('layouts.pageLayout.price_level') +
                          ' ' +
                          customerPriceLevel +
                          ')'}
                      </div>
                      {/* <div className="credit">{translate('availableCredit')}:{userCredit}</div> */}
                    </div>
                    <MediaQuery query='(min-device-width: 1024px)'>
                      <CustomerActionRow
                        customerAction={this.changeOrderTypeAndReloadProducts}
                        invertClass={'invert-color'}
                        activeOrderType={orderType}
                        openOrders={customerOrderTypes}
                        labelBasic={translate(
                          'routes.customerList.customerActionRow.action_basic'
                        )}
                        labelSpecial={translate(
                          'routes.customerList.customerActionRow.action_special'
                        )}
                        labelClaim={translate(
                          'routes.customerList.customerActionRow.action_claim'
                        )}
                        labelWarehouse={translate(
                          'routes.customerList.customerActionRow.action_warehouse'
                        )}
                        labelCommission={translate(
                          'routes.customerList.customerActionRow.action_commision'
                        )}
                      />
                      <Button
                        color='danger'
                        onClick={() => submitOpenedOrders(customerId)}
                        title={translate('layouts.pageLayout.submitOpenedOrders')}
                      >
                        <i className='fa fa-check-square-o' />
                      </Button>
                    </MediaQuery>
                    <div className='change_customer'>
                      <Link to='/'>
                        {translate('layouts.pageLayout.change_customer')}
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <Collapse isOpen={showCustomerDetail}>
                        <CustomerDetailSection fetch={showCustomerDetail} />
                      </Collapse>
                    </div>
                  </div>

                  <MediaQuery query='(max-device-width: 1023px)'>
                    <div className='header__customer'>
                      <CustomerActionRow
                        customerAction={this.changeOrderTypeAndReloadProducts}
                        invertClass={'invert-color'}
                        activeOrderType={orderType}
                        openOrders={customerOrderTypes}
                        labelBasic={translate(
                          'routes.customerList.customerActionRow.action_basic'
                        )}
                        labelSpecial={translate(
                          'routes.customerList.customerActionRow.action_special'
                        )}
                        labelClaim={translate(
                          'routes.customerList.customerActionRow.action_claim'
                        )}
                        labelWarehouse={translate(
                          'routes.customerList.customerActionRow.action_warehouse'
                        )}
                        labelCommission={translate(
                          'routes.customerList.customerActionRow.action_commision'
                        )}
                      />
                      <Button
                        color='danger'
                        onClick={() => submitOpenedOrders(customerId)}
                        title={translate('layouts.pageLayout.submitOpenedOrders')}
                      >
                        <i className='fa fa-check-square-o' />
                      </Button>
                    </div>
                  </MediaQuery>
                </React.Fragment>
              ) : null}
            {main}
          </div>
        </div>
        <LoginModal
          isOpen={isOpen}
          message={translate('layouts.pageLayout.change_customer')}
        />

        <OrderModalContainer />
        <ProductModalContainer />
        <SubmitOpenedOrderModal />
        <ConfirmOrderModal />
        <ErrorModal />
        <CustomerCartModal />
      </React.Fragment>
    )
  }
}
PageLayout.propTypes = {
  children: PropTypes.node,
  toggleCart: PropTypes.func,
  isCartOpened: PropTypes.bool,
  getTotal: PropTypes.string,
  getItemsCount: PropTypes.string,
}

const mapStateToProps = state => ({
  isSearchLoading: isSearchLoading(state.common.searchLoading),
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
  isLoading: isLoading(state.common.loading),
  isUserLoggedIn: isUserLoggedIn(state.common.token),
  isCartOpened: isCartOpened(state.common.cartOpen),
  currentPage: getCurrentPathname(state.location.pathname),
  customerId:
    state.common && state.common.user && state.common.user.personal
      ? state.common.user.personal.id
      : null,
  customer:
    state.common && state.common.user && state.common.user.personal
      ? state.common.user.personal.code
      : null,
  customerDiscount:
    state.common && state.common.user && state.common.user.personal.discount
      ? state.common.user.personal.discount
      : null,
  customerPriceLevel:
    state.common &&
      state.common.user &&
      state.common.user.personal.price_level &&
      state.common.user.personal.price_level !== 'A'
      ? state.common.user.personal.price_level
      : null,
  openedOrders: state.common.user.orderType,
  commonState: state.common,
  isOpen: state.common.isLoginModalOpen,
  isCategoryOpen: state.common.categorySidebarOpen,
  isOrderTypeDropdownOpen: state.common.orderTypeDropdownOpen,
  customerOrderTypes: state.common.user.orderType,
  orderTypes: state.common.orderTypes,
  orderType: state.customer.actionOnCustomer,
  userCredit: state.common.user.credit,
  showCustomerDetail: state.common.customerDetail,
})

const mapDispatchToProps = {
  toggleCategorySidebar,
  toggleOrderTypeDropdown,
  customerActionType,
  submitOpenedOrders,
  toggleCustomerDetail,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageLayout)



// WEBPACK FOOTER //
// ./src/layouts/PageLayout.js